<script>
import { Radar } from 'vue-chartjs'
import moment from 'moment'

export default {
    extends: Radar,
    props: ['period'],
    data() {
        return {
            hours: [],
            rx_bytes: [],
            tx_bytes: [],
            data: '',
            colors: [],

        }

    },
    methods: {

        getUtcOffset(date) {

            return moment(date).format('Z');
        },

        getData() {
            // console.log(this.tf);

            this.gradient = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 450);
            this.gradient2 = this.$refs.canvas
                .getContext("2d")
                .createLinearGradient(0, 0, 0, 450);

            this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
            this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
            this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

            this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
            this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
            this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

            let x = new Date();
            let offset = encodeURIComponent(this.getUtcOffset(x));
            let uri = `/api/dashboard?node=hour_traffic&tz=${offset}&period=${this.period}`;

            axios.get(uri, {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(response => {
                    this.data = response.data.data;
                    if (this.data) {
                        this.data.forEach(element => {
                            ;
                            this.hours.push(element.hour);
                            this.rx_bytes.push(element.rx_bytes);
                            this.tx_bytes.push(element.tx_bytes);

                        });
                        this.renderChart({

                            labels: this.hours,

                            datasets: [{
                                    label: "Upload (GB)",
                                    // backgroundColor: this.gradient,
                                    // borderColor: "#FC2525",
                                    // pointBackgroundColor: "white",
                                    // pointBorderColor: "white",
                                    // pointHoverBackgroundColor: "#fff",
                                    // pointHoverBorderColor: "rgba(179,181,198,1)",

                                    backgroundColor: "rgba(255,99,132,0.2)",
                                    borderColor: "rgba(255,99,132,1)",
                                    pointBackgroundColor: "rgba(255,99,132,1)",
                                    pointBorderColor: "#fff",
                                    pointHoverBackgroundColor: "#fff",
                                    pointHoverBorderColor: "rgba(255,99,132,1)",

                                    data: this.rx_bytes
                                },
                                {
                                    label: "Download (GB)",
                                    backgroundColor: this.gradient2,
                                    borderColor: "#05CBE1",
                                    pointBackgroundColor: "white",
                                    pointBorderColor: "white",
                                    pointHoverBackgroundColor: "#fff",
                                    pointHoverBorderColor: "rgba(255,99,132,1)",
                                    data: this.tx_bytes
                                }
                            ]
                        }, {
                            title: {
                                display: true,
                                text: 'Traffic by Hour',
                                fontSize: 16,
                            },
                            responsive: true,
                            maintainAspectRatio: false,

                        })

                    } else {
                        console.log('NO DATA');
                    }
                }).catch(error => {

                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', error.message);
                    }
                    console.log(error.config);

                })

        },

    },

    mounted() {
        this.getData();
    }
}
</script>
